export default "__VITE_ASSET__34e0e043__"